import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Layout } from "../Layout";
import { Seo } from "../../seo/Seo";
import { About } from "../About";
import { Process } from "../Process";
import { Reveal } from "../Reveal";

export default function AboutPage() {
  return (
    <Layout>
      <Seo path="/about" />
      <section className="page-hero" data-testid="about-page-hero">
        <div className="wrap">
          <Reveal>
            <h1 className="page-title" data-testid="about-page-title">About KR Studio</h1>
          </Reveal>
        </div>
      </section>
      <About />
      <Process />
      <section className="section section-dark cta-band" data-testid="about-cta-band">
        <div className="wrap cta-band-inner">
          <h2>Have a project in mind?</h2>
          <Link to="/contact" className="btn btn-primary" data-testid="about-cta-start-project">
            Start a project <ArrowUpRight size={17} strokeWidth={2.5} />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
